import { render, staticRenderFns } from "./RuralContactDeleteForm.vue?vue&type=template&id=5887f722&scoped=true&"
import script from "./RuralContactDeleteForm.vue?vue&type=script&lang=js&"
export * from "./RuralContactDeleteForm.vue?vue&type=script&lang=js&"
import style0 from "./RuralContactDeleteForm.vue?vue&type=style&index=0&id=5887f722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5887f722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VForm,VRow})
